module.exports = __webpack_public_path__ + "img/symphony_672_sky.b0a9a536.jpg";